import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { borderRadius, colors, gridSize } from '@atlaskit/theme';
export var ShowMoreWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-top: ", "px;\n  padding: ", "px;\n  padding-bottom: 0;\n  border-top: 1px solid #dfe1e6;\n\n  > button {\n    flex-grow: 1;\n  }\n"], ["\n  display: flex;\n  margin-top: ", "px;\n  padding: ", "px;\n  padding-bottom: 0;\n  border-top: 1px solid #dfe1e6;\n\n  > button {\n    flex-grow: 1;\n  }\n"])), gridSize() / 2, gridSize() / 2);
export var TextColorIconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var TextColorIconBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 16px;\n  margin: auto;\n  width: 12px;\n  height: 3px;\n  border-radius: ", ";\n\n  ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 16px;\n  margin: auto;\n  width: 12px;\n  height: 3px;\n  border-radius: ", ";\n\n  ",
    ";\n"])), borderRadius() + 'px', function (_a) {
    var gradientColors = _a.gradientColors, selectedColor = _a.selectedColor;
    if (selectedColor) {
        return "background: " + selectedColor;
    }
    return "background: " + gradientColors;
});
var createSteppedRainbow = function (colors) {
    return "\n    linear-gradient(\n      to right,\n      " + colors
        .map(function (color, i) {
        var inc = 100 / colors.length;
        var pos = i + 1;
        if (i === 0) {
            return color + " " + pos * inc + "%,";
        }
        if (i === colors.length - 1) {
            return color + " " + (pos - 1) * inc + "%";
        }
        return "\n            " + color + " " + (pos - 1) * inc + "%,\n            " + color + " " + pos * inc + "%,\n          ";
    })
        .join('\n') + "\n    );\n    ";
};
export var rainbow = createSteppedRainbow([
    colors.P300,
    colors.T300,
    colors.Y400,
    colors.R400,
]);
export var disabledRainbow = createSteppedRainbow([
    colors.N80,
    colors.N60,
    colors.N40,
    colors.N60,
]);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map